module.exports = __webpack_public_path__ + "img/logo_3.3a1bdce4.png";